import axios from 'axios';

const API = axios.create();

export const test = (newPost) => axios.post('https://fastpres.herokuapp.com/pptx/', newPost, {responseType: 'blob'});

// https://fastpres.herokuapp.com/
//http://localhost:8000/pptx/